import SearchAdventure from '@/components/search-adventure';

import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';

export type SpecialtySearchAdventureProps = {
  id: string;
};

export default function SpecialtySearchAdventure(
  props: SpecialtySearchAdventureProps
) {
  const { specialty, specialtyPageStaticData } = useSpecialtyPageContext();
  if (!specialty || !specialty.discipline || !specialtyPageStaticData)
    return null;

  const searchAdventureData =
    specialtyPageStaticData.searchAdventures[props.id];
  if (!searchAdventureData) return null;

  return (
    <SearchAdventure
      specialty={specialty}
      specialties={searchAdventureData.specialties}
      regions={searchAdventureData.regions}
    />
  );
}
